import { attendanceSessionConstants } from '../../constants';
import { attendanceStudentRecordConstants } from '../../constants/attendanceStudentRecord.constants';

const initialAttendanceStudentRecordsState = {
    attendanceStudentRecordsList: [] as any[],
};

export function attendanceStudentRecords(state = initialAttendanceStudentRecordsState, action: any) {
  switch (action.type) {
    case attendanceStudentRecordConstants.GET_BY_SESSION_REQUEST:
      return { ...state, loading: true };
    case attendanceStudentRecordConstants.GET_BY_SESSION_SUCCESS:
      return { ...state, attendanceStudentRecordsList: action.payload, loading: false };
    case attendanceStudentRecordConstants.GET_BY_MONTH_REQUEST:
      return { ...state, loading: true };
    case attendanceStudentRecordConstants.GET_BY_MONTH_SUCCESS:
      return { ...state, attendanceStudentRecordsList: action.payload };
      case attendanceStudentRecordConstants.GET_BY_MONTHS_AND_STUDENT_SUCCESS:
    return { ...state, attendanceStudentRecordsList: action.payload };
    case attendanceStudentRecordConstants.ADD_NEW_STUDENT_RECORDS_SUCCESS:
      const updatedAttendanceStudentRecordsList = [...state.attendanceStudentRecordsList, ...action.payload]
      return { ...state, attendanceStudentRecordsList: updatedAttendanceStudentRecordsList };
    case attendanceStudentRecordConstants.UPDATE_NEW_STUDENT_RECORDS_SUCCESS: {
      // Tạo một Map từ danh sách hiện tại để tra cứu nhanh
      const recordMap = new Map(state.attendanceStudentRecordsList.map((record: { id: any }) => [record.id, record]));
      // Duyệt qua các bản ghi mới và cập nhật hoặc thêm vào Map
      action.payload.forEach((newRecord: { id: any }) => {
        recordMap.set(newRecord.id, newRecord); // Nếu có thì update, nếu không thì thêm mới
      });
      return {
        ...state,
        attendanceStudentRecordsList: Array.from(recordMap.values()), // Chuyển Map thành mảng
      };
    }
    case attendanceStudentRecordConstants.GET_BY_MONTH_FAILURE:
      return { ...state, error: action.payload };    
    default:
      return state;
  }
}
